import { createSlice } from '@reduxjs/toolkit';

const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: {
        isCollapsed: false
    },
    reducers: {
        collapse: (state) => {
            state.isCollapsed = true;
        },
        expand: (state) => {
            state.isCollapsed = false;
        }
    }
});

export const { collapse, expand } = sidebarSlice.actions;

export default sidebarSlice;